type CoursesLocale = typeof import('../en/courses').default

const courses = {
	index: {
		title: '{{mainEntityLabelPlural}}',
		subtitle:
			'Explora nuestro catálogo completo de {{mainEntityLabelPluralLower}} diseñados para ayudarte a dominar nuevas habilidades',
		noCourses: 'No se encontraron {{mainEntityLabelPluralLower}}',
		tryDifferentFilters: 'Prueba con filtros diferentes o vuelve más tarde',
		searchPlaceholder: 'Buscar {{mainEntityLabelPluralLower}}...',
		moveModule: 'Mover módulo',
	},
	catalog: {
		zones: {
			programsHint:
				'{{collectionEntityLabelPlural}} que conectan {{mainEntityLabelPluralLower}} en una secuencia con criterio.',
		},
		meta: {
			title: {
				default:
					'Catálogo de {{mainEntityLabelPluralLower}} y {{collectionEntityLabelPluralLower}}',
				courseType: '{{mainEntityLabelPlural}}',
				collectionType: '{{collectionEntityLabelPlural}}',
				category: '{{category}} | {{mainEntityLabelPlural}}',
				subcategory: '{{subcategory}} | {{mainEntityLabelPlural}}',
				pageSuffix: 'Página {{page}}',
			},
			description: {
				default:
					'Explora el catálogo de {{mainEntityLabelPluralLower}} y {{collectionEntityLabelPluralLower}} en {{brandTitle}}.',
				courseType:
					'Explora {{mainEntityLabelPluralLower}} para aprender con criterio en {{brandTitle}}.',
				collectionType:
					'Descubre {{collectionEntityLabelPluralLower}} estructurad{{collectionEntityGenderSuffixPlural}} en {{brandTitle}}.',
				category:
					'Explora {{mainEntityLabelPluralLower}} de {{category}} en {{brandTitle}}.',
				subcategory:
					'Explora {{mainEntityLabelPluralLower}} de {{subcategory}} en {{brandTitle}}.',
			},
		},
	},
	entities: {
		course: {
			title: '{{mainEntityLabel}}',
			createCourse: 'Crear {{mainEntityLabelLower}}',
			deleteCourse: 'Eliminar {{mainEntityLabelLower}}',
		},
		module: {
			title: 'Módulo',
			createModule: 'Crear módulo',
			newModule: 'Nuevo módulo',
			deleteModule: 'Eliminar módulo',
		},
		topic: {
			title: 'Tema',
			createTopic: 'Crear tema',
			newTopic: 'Nuevo tema',
			deleteTopic: 'Eliminar tema',
		},
		resource: {
			title: 'Recurso',
			titlePlural: 'Recursos',
			createResource: 'Crear recurso',
			deleteResource: 'Eliminar recurso',
		},
	},
	detail: {
		breadcrumb: {
			courses: '{{mainEntityLabelPlural}}',
		},
		enroll: 'Inscribirse ahora',
		enrolling: 'Inscribiendo...',
		continueLearning: 'Continuar aprendiendo',
		whatYouWillLearn: 'Lo que aprenderás',
		relatedCourses:
			'{{mainEntityLabelPlural}} relacionad{{mainEntityGenderSuffixPlural}}',
		applicability: {
			appliesTo: 'Aplica a {{country}}',
			needsReview: 'Pendiente de revisión normativa',
			deprecated: 'Normativa desactualizada',
		},
		hero: {
			enroll: 'Empieza gratis',
			startLearning:
				'Empezar {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}}',
			continueLearning: 'Continúa aprendiendo',
		},
		stickyCta: {
			stateEnrolled: '{{mainEntityLabel}} activad{{mainEntityGenderSuffix}}',
			stateProgramEnrolled:
				'{{collectionEntityLabel}} activad{{collectionEntityGenderSuffix}}',
			stateLoggedIn: 'Listo para empezar',
			stateAnonymous: 'Acceso rápido',
			description:
				'Accede a {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} sin perder el contexto actual.',
			descriptionProgram:
				'Accede a {{collectionEntityDemonstrativeLower}} {{collectionEntityLabelLower}} sin perder el contexto actual.',
		},
		valueProps: {
			title: 'Una nueva forma de aprender',
			subtitle:
				'Combina contenido seleccionado con el poder de la IA para iniciar tu  experiencia de aprendizaje personalizada',
			features: {
				curated: {
					title: 'Contenido seleccionado',
					description:
						'Recursos seleccionados de plataformas como YouTube, las mejores publicaciones y más',
				},
				ai: {
					title: 'Potenciado por IA',
					description:
						'Contenido personalizado usando IA avanzada que se adapta a tus objetivos e intereses',
				},
				notes: {
					title: 'Toma tus notas',
					description:
						'Toma notas, resalta conceptos clave y crea tus propios materiales de estudio',
				},
				visual: {
					title: 'Aprendizaje visual',
					description:
						'Disfruta de los mejores vídeos seleccionados y entiende los conceptos con diagramas interactivos',
				},
			},
		},
		objectives: {
			title: 'Lo que aprenderás',
		},
		metadataObjectives: {
			title: 'Objetivos',
		},
		highlights: {
			title: 'Puntos clave',
		},
		curriculum: {
			title: 'Contenido',
			highlightsTitle:
				'Claves {{collectionEntityArticleWithDeLower}} {{collectionEntityLabelLower}}',
			topics: 'temas',
			modules: 'módulos',
		},
		faq: {
			title: 'Preguntas frecuentes',
		},
		related: {
			title: 'Más en {{category}}',
			fallbackTitle:
				'Más {{mainEntityLabelPluralLower}} recomendad{{mainEntityGenderSuffixPlural}}',
		},
		relationship: {
			eyebrow: 'Pertenece a',
			single:
				'{{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} forma parte de {{collectionEntityArticleLower}} {{collection}}',
			multiple:
				'{{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} forma parte de {{count}} {{collectionEntityLabelPluralLower}}',
			cta: 'Ver {{collectionEntityLabelLower}}',
		},
		collectionContext: {
			actions: {
				openCollection: 'Abrir {{collectionEntityLabelLower}}',
				viewCollection:
					'Ver {{collectionEntityLabelLower}} complet{{collectionEntityGenderSuffix}}',
				startThisCourse:
					'Empezar {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}}',
				takeCourseOnly:
					'Tomar solo {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}}',
				addCollection: 'Añadir {{collectionEntityLabelLower}}',
				chooseProgram: 'Elegir {{collectionEntityLabelLower}}',
			},
			disambiguation: {
				title: '¿Dónde quieres continuar?',
				openProgram: 'Abrir',
				takeCourseOnly:
					'Tomar solo {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}}',
			},
			promote: {
				eyebrow: 'Recomendado',
				title:
					'Haz {{mainEntityArticleLower}} {{mainEntityLabelLower}} dentro de: {{collection}}',
				description:
					'Verás el recorrido completo, el progreso conjunto y el siguiente paso {{collectionEntityArticleWithDeLower}} {{collectionEntityLabelLower}}.',
			},
			resume: {
				eyebrow:
					'Ya estás en {{collectionEntityArticleLower}} {{collectionEntityLabelLower}}',
				title: '{{collection}} ya forma parte de tu panel',
				description:
					'Entra por {{collectionEntityArticleLower}} {{collectionEntityLabelLower}} para mantener el contexto y retomar el siguiente paso desde una vista unificada.',
			},
			attach: {
				eyebrow: 'Amplía el contexto',
				title: 'Añade {{collection}} a tu panel',
				description:
					'Ya has empezado {{mainEntityArticleLower}} {{mainEntityLabelLower}}. Si añades también {{collectionEntityArticleLower}} {{collectionEntityLabelLower}}, tendrás el recorrido completo en un solo lugar.',
			},
			finalCta: {
				title:
					'Empieza mejor con {{collectionEntityArticleLower}} {{collectionEntityLabelLower}} complet{{collectionEntityGenderSuffix}}',
				subtitle:
					'{{collection}} reúne {{mainEntityArticleLower}} {{mainEntityLabelLower}} con el contexto y los siguientes pasos para avanzar con más claridad.',
			},
		},
		otherCollections: {
			title: 'Otros {{collectionEntityLabelPluralLower}}',
			cta: 'Ver {{collectionEntityLabelLower}}',
		},
		experience: {
			genericTitle: 'Qué puedes esperar de este recorrido',
			genericIntro:
				'Una estructura clara para ganar tracción, mantener el contexto y conectar cada paso con lo que viene después.',
			points: {
				guidedPace: {
					title: 'Un ritmo guiado que es fácil retomar',
					description:
						'Cada bloque te ayuda a entender qué abordar primero y cómo continuar sin perder el hilo.',
				},
				connectedContext: {
					title: 'Contenido que se mantiene conectado',
					description:
						'El contenido y los módulos están ordenados para que la relación entre conceptos siga visible a medida que avanzas.',
				},
				practicalProgress: {
					title: 'Progreso práctico desde el principio',
					description:
						'No solo acumulas contenido. Construyes criterio y una forma práctica de aplicar lo que aprendes.',
				},
			},
		},
		finalCta: {
			title: 'Comienza a aprender hoy',
			subtitle: 'Empieza cuando quieras y avanza a tu ritmo',
			titleLoggedIn: '¿Listo para empezar?',
			subtitleLoggedIn: 'Inscríbete en {{course}} para comenzar ahora',
			titleEnrolled: 'Continúa tu camino',
			subtitleEnrolled: 'Sigue aprendiendo con {{course}}',
			enrollButton: 'Inscribirse ahora',
			enrollButtonLoggedIn:
				'Empezar {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}}',
			continueButton: 'Continuar aprendiendo',
		},
		enrollmentDialog: {
			whatYouCanDo: 'Qué ocurre al registrarte',
			common: {
				createAccount: 'Crear cuenta y empezar aquí',
				signIn: 'Ya tengo cuenta',
				viewPlans: 'Ver planes',
				manageBilling: 'Ir a facturación',
				keepBrowsing: 'seguir explorando el catálogo',
			},
			anonymous: {
				title:
					'Crea tu cuenta y empieza por {{mainEntityArticleLower}} {{mainEntityLabelLower}}',
				description:
					'Regístrate gratis para guardar esta elección. Al crear la cuenta podrás usar un{{mainEntityGenderSuffix}} de tus dos {{mainEntityLabelPluralLower}} gratuit{{mainEntityGenderSuffixPlural}} aquí y seguir explorando el catálogo.',
				benefitDefault:
					'Empieza por {{mainEntityArticleLower}} {{mainEntityLabelLower}} que estás viendo, sin pasar por {{collectionEntityArticleLower}} {{collectionEntityLabelLower}} genéric{{collectionEntityGenderSuffix}}.',
				benefitLogin:
					'Si ya tienes cuenta, entra y vuelve a esta misma página para continuar.',
				benefitCatalog:
					'Puedes comparar planes o seguir explorando antes de decidir en qué dos {{mainEntityLabelPluralLower}} empezar.',
				catalogHint:
					'Si quieres ver el acceso completo antes de registrarte, puedes',
			},
			upgrade: {
				title:
					'{{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} está incluid{{mainEntityGenderSuffix}} en el plan premium',
				description:
					'Tu cuenta ya está lista. Activa un plan para acceder a {{course}} y al resto del catálogo premium.',
				benefitAccess:
					'Desbloquea {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} y el resto de contenidos premium en cuanto actives tu plan.',
				benefitBilling:
					'Gestiona el upgrade desde facturación sin perder el contexto {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}} que estabas viendo.',
				benefitPlans:
					'Si aún estás comparando opciones, revisa los planes antes de decidir.',
				catalogHint: 'Mientras decides, puedes',
			},
			confirmation: {
				title:
					'Elige {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} para tu cuenta',
				description:
					'{{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} se quedará en tu cuenta para siempre. Después de esta elección te quedará(n) {{remaining}} desbloqueo(s).',
				benefitPermanent:
					'{{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} se añade a tu cuenta para siempre.',
				benefitRemaining:
					'Después de desbloquearl{{mainEntityGenderSuffix}}, aún te quedará(n) {{remaining}} desbloqueo(s) de {{mainEntityLabelLower}} por elegir.',
				benefitCatalog:
					'Puedes seguir explorando antes de gastar tus desbloqueos restantes.',
				catalogHint: 'Si prefieres comparar primero, todavía puedes',
				cancel: 'Volver al catálogo',
				confirm: 'Desbloquear {{mainEntityLabelLower}}',
			},
			transientError: 'Ha habido un problema al inscribirte.',
			retryButton: 'Inténtalo de nuevo',
		},
	},
	viewModes: {
		content: 'Contenido',
		materials: 'Materiales',
		diagram: 'Diagrama',
		notes: 'Notas',
	},
	categories: {
		subcategories: {
			title: 'Subcategorías',
		},
		featuredCourses:
			'{{mainEntityLabelPlural}} destacad{{mainEntityGenderSuffixPlural}}',
	},
	subcategories: {
		noCourses: 'Aún no hay {{mainEntityLabelPluralLower}} en esta subcategoría',
		checkBackLater:
			'Vuelve más tarde para ver nuevos {{mainEntityLabelPluralLower}}',
	},
	filters: {
		title: 'Filtros',
		type: 'Tipo',
		itineraries: '{{collectionEntityLabelPlural}}',
		routes: '{{mainEntityLabelPlural}}',
		categories: 'Categorías',
		subcategories: 'Subcategorías',
		apply: 'Aplicar',
		selectCategoryFirst: 'Selecciona una categoría primero',
		mobileDescription: 'Refina el catálogo por categorías y subcategorías.',
		topics: 'Temas',
		languages: 'Idiomas',
		level: 'Nivel',
		levels: {
			beginner: 'Principiante',
			intermediate: 'Intermedio',
			advanced: 'Avanzado',
		},
		showMore: 'Mostrar {{count}} más',
		showLess: 'Mostrar menos',
		clearAll: 'Limpiar todo',
		country: 'País',
		countryScopeNote: 'Contenido orientado a {{country}}',
		sortLabel: 'Ordenar:',
		sort: {
			featured: 'Destacados',
			newest: 'Más recientes',
			popular: 'Más populares',
		},
	},
	search: {
		placeholder: 'Buscar {{mainEntityLabelPluralLower}}...',
		results: 'Resultados de búsqueda',
		noResults: 'No se encontraron resultados',
		tryDifferentKeywords: 'Prueba con palabras clave diferentes',
	},
	enrollment: {
		success:
			'Te has inscrito exitosamente en {{mainEntityArticleLower}} {{mainEntityLabelLower}}',
		error:
			'Error al inscribirse en {{mainEntityArticleLower}} {{mainEntityLabelLower}}',
		alreadyEnrolled:
			'Ya estás inscrito en {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}}',
	},
	enrollmentErrors: {
		courseUnavailable: '{{mainEntityLabel}} no disponible',
		enrollmentDisabled:
			'La inscripción en {{mainEntityArticleLower}} {{mainEntityLabelLower}} está deshabilitada',
		subscriptionRequired:
			'Se requiere suscripción de pago para {{mainEntityArticleLower}} {{mainEntityLabelLower}}',
		confirmationRequired:
			'Confirma primero que quieres gastar un desbloqueo {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}.',
		paywallRequired:
			'Ya has usado tus desbloqueos {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}. Pásate a Pro para continuar.',
		validationFailed: 'Validación fallida',
		enrollmentFailed: 'No se pudo crear la inscripción',
		updateFailed: 'No se pudo actualizar la inscripción',
	},
	preparation: {
		processing: 'Preparando el contenido...',
		processingDescription:
			'Estamos buscando recursos y generando contenido. Esto puede llevar unos minutos.',
		completed: '¡Creación completada!',
		completedDescription:
			'Tu {{mainEntityLabelLower}} ahora tiene recursos y contenido adicionales.',
		tracker: {
			initialModuleCompleted:
				'La preparación inicial cubre el primer módulo. El texto de los siguientes temas se prepara al abrirlos.',
			initialModuleTopicsReady:
				'{{ready}} de {{total}} temas del alcance inicial con texto disponible',
			preparingStructure: 'Preparando estructura y acceso',
			preparingStructureDescription:
				'Estamos preparando la estructura {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}} para que puedas recorrerla con normalidad.',
			attachingResources: 'Buscando y adjuntando recursos',
			attachingResourcesDescription:
				'Estamos descubriendo y enlazando los primeros recursos útiles para {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}}.',
			creatingContent: 'Creando contenido',
			creatingContentDescription:
				'Estamos preparando en segundo plano el contenido de aprendizaje.',
			syncingCourse: 'Actualizando tu {{mainEntityLabelLower}}',
			syncingCourseDescription:
				'Estamos copiando ahora en tu {{mainEntityLabelLower}} los nuevos recursos y contenidos.',
			topicsReady: '{{ready}} de {{total}} temas con contenido listo',
			expectation:
				'Suele tardar unos minutos. Puedes seguir navegando: los temas se irán activando solos.',
			delayed:
				'Está tardando más de lo normal. Puedes seguir usando {{mainEntityArticleLower}} {{mainEntityLabelLower}}: seguiremos completándol{{mainEntityGenderSuffix}} en segundo plano.',
			completedTitle:
				'Tu {{mainEntityLabelLower}} está list{{mainEntityGenderSuffix}}',
			completedDescription:
				'La preparación ha terminado. Todo el contenido inicial está ya listo.',
		},
	},
	preparationGate: {
		eyebrow: 'Preparando {{mainEntityArticleLower}} {{mainEntityLabelLower}}',
		title: 'Estamos preparando tu {{mainEntityLabelLower}}',
		description:
			'Estamos dejando {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} list{{mainEntityGenderSuffix}} para ti. En un par de minutos podrás entrar y empezar con normalidad.',
		note: 'Puedes esperar aqu\u00ed mientras termina la preparaci\u00f3n.',
		timeoutTitle: 'La preparación está tardando más de lo esperado',
		timeoutDescription:
			'La preparación del curso puede haber encontrado un problema. Prueba a recargar la página o vuelve más tarde.',
		retry: 'Reintentar',
	},
	preparationFallback: {
		title:
			'{{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}} está disponible con preparación parcial',
		description:
			'Algunos pasos de enriquecimiento compartido no terminaron, así que puedes continuar con la estructura actual {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}} mientras se recupera lo que falta.',
	},
	emptyModules: {
		title: 'Este curso todavía no tiene módulos',
		ownerDescription: 'Crea un módulo para volver a organizar el curso',
		viewerDescription:
			'El contenido aparecerá aquí cuando haya módulos disponibles.',
		moduleTitlePlaceholder: 'Título del módulo',
		createModule: 'Crear módulo',
	},
	progress: {
		completed: 'Completado',
		inProgress: 'En progreso',
		notStarted: 'No iniciado',
	},
	addModulesAndTopics: 'Añadir módulos y temas',
	addModulesAndTopicsDescription:
		'Ingresa nombres de módulos con prefijo "-". Temas bajo cada módulo en nuevas líneas.',
	bulkPlaceholder: '- Módulo 1\nTema A\nTema B\n- Módulo 2\nTema C',
	createStudyPlan: {
		title: 'Crear plan de estudio',
		advanced: 'Avanzado',
		beginner: 'Principiante',
		courseLength:
			'Duración {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}} (semanas)',
		courseName:
			'Nombre {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
		courseNamePlaceholder: 'p.ej., Introducción a la computación cuántica',
		courseType:
			'Tipo {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
		description:
			'Configura los detalles para tu nuevo plan de estudio. Se creará una estructura con módulos y temas basada en tus preferencias.',
		english: 'Inglés',
		expertiseLevel: 'Nivel de experiencia',
		foundational: 'Fundacional',
		foundationalDescription:
			'Construye una comprensión teórica sólida del tema.',
		generate: 'Generar plan',
		intermediate: 'Intermedio',
		language: 'Idioma',
		practical: 'Práctico',
		practicalDescription:
			'Enfócate en proyectos prácticos y aplicaciones del mundo real.',
		selectLanguage: 'Seleccionar idioma',
		selectLevel: 'Seleccionar nivel',
		spanish: 'Español',
		topicsPerWeek: 'Temas por semana',
	},
	createCourseDiagram: {
		title:
			'Crear diagrama {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
	},
	createCourseRouteCards: {
		title:
			'Generar tarjetas {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
	},
	moduleQuickActions: {
		prepareSummaries: 'Preparar resúmenes',
	},
	topicQuickActions: {
		summary: 'Preparar resumen',
		deepDive: 'Preparar desarrollo',
		curateResources: 'Recopilar recursos',
		deepen: 'Profundizar',
		moreContent: 'Más opciones de contenido',
		moreResources: 'Más opciones de recursos',
	},
	topics: {
		study: {
			contentLabel: 'Contenido del tema',
			progressLabel: '{{current}} de {{total}}',
			progressAria: 'Avance de lectura del tema',
			resumeTitle: 'Te quedaste aquí',
			resumeIn: 'en «{{section}}»',
			resumeAction: 'Seguir',
			furtherTitle: 'Para seguir',
			openOriginal: 'Abrir el original',
			resourcesCount_one: '{{count}} recurso',
			resourcesCount_other: '{{count}} recursos',
			backToText: 'Volver al texto',
			deleteResourceTitle: '¿Quitar este recurso del tema?',
			deleteResourceDescription: 'Dejará de aparecer en «Para seguir».',
			resourceActionFailed: 'No se ha podido hacer. Inténtalo de nuevo.',
			untitledResource: 'Recurso sin título',
			markStudied: 'Marcar como estudiado',
			studied: 'Estudiado',
			publicDomain: 'Dominio público',
			figureSource: 'Fuente',
			topicsDone: '{{done}} de {{total}} temas',
			continueHere: 'Sigue aquí',
			statusStarted: 'Empezado',
			statusStudied: 'Estudiado',
			nextTopic: 'Siguiente tema',
			nextTopicNumbered: 'Siguiente · Tema {{number}}',
			sectionsCount_one: '{{count}} sección',
			sectionsCount_other: '{{count}} secciones',
			resumeDismiss: 'Descartar',
			figureSourceLabel: 'Fuente de la figura: {{caption}}',
			homeStart: 'Empezar',
			homeContinue: 'Seguir',
			homeTopic: 'Tema {{number}}',
			notesTitle: 'Tus notas',
			notesPlaceholder: 'Anota lo que quieras recordar.',
			tableLabel: 'Tabla, se desplaza en horizontal',
			keyPoints: 'Puntos clave',
			indexLabel: 'Curso',
			indexHide: 'Ocultar el índice',
			indexShow: 'Mostrar el índice',
			backToTop: 'Volver arriba',
			resourceType: {
				video: 'Vídeo',
				post: 'Artículo',
				book: 'Libro',
				pdf: 'PDF',
				image: 'Imagen',
				url: 'Enlace',
				file: 'Archivo',
			},
		},
		preparing: {
			title: 'Preparando este tema',
			description:
				'Estamos copiando recursos y contenido en segundo plano. El tema aparecerá aquí cuando termine la actualización.',
		},
		textPreparation: {
			failed: 'No se pudo preparar el texto del tema',
			description:
				'El texto aparecerá aquí cuando termine la preparación. Ya puedes consultar los recursos.',
			retry: 'Volver a preparar el texto',
			depthRetry: 'Volver a intentarlo',
			summaryOnly: 'Estás leyendo el resumen de este tema',
			depth: {
				pending:
					'El contenido en profundidad está en cola. Aparecerá aquí sin recargar la página.',
				generating:
					'Estamos escribiendo el contenido en profundidad. Aparecerá aquí en unos minutos, sin recargar la página.',
				failed:
					'No se pudo preparar el contenido en profundidad. Puedes seguir con el resumen y los recursos.',
			},
		},
		zeroState: {
			notes: 'Escribe una nota rápida para empezar.',
			resources: 'Añade fuentes y materiales para este tema.',
			content: 'Crea la primera pieza de contenido del tema.',
		},
		notFound: {
			title: 'Tema no encontrado',
			message: 'El tema que buscas no existe o no tienes permisos para verlo.',
			backToCourses: 'Volver a mis {{mainEntityLabelPluralLower}}',
		},
	},
	resources: {
		notFound: 'Recurso no encontrado',
		noContent: 'No hay contenido disponible',
		loading: 'Cargando recurso...',
		errorLoading: 'Error al cargar recurso',
		tableOfContents: 'Tabla de contenidos',
		notes: 'Notas',
		noNotes: 'No hay notas disponibles',
		navigation: {
			previous: 'Anterior',
			next: 'Siguiente',
			backToResources: 'Volver a recursos',
		},
		actions: {
			download: 'Descargar',
			share: 'Compartir',
			addNote: 'Añadir nota',
			edit: 'Editar recurso',
		},
		messages: {
			courseNotFound:
				'{{mainEntityLabel}} no encontrad{{mainEntityGenderSuffix}}',
			resourceNotFound: 'El recurso solicitado no se pudo encontrar.',
			topicNotFound: 'Tema no encontrado',
			moduleNotFound: 'Módulo no encontrado',
			notEnrolled:
				'No estás inscrito en {{mainEntityDemonstrativeLower}} {{mainEntityLabelLower}}',
			accessDenied: 'No tienes permisos para ver este recurso',
		},
		book: {
			error: 'Error al cargar el recurso',
			errorDescription: 'No hay información disponible para este libro',
			viewFull: 'Ver completo',
			by: 'por',
			authors: 'Autores',
			author: 'Autor',
			publisher: 'Editorial',
			publishedDate: 'Fecha de publicación',
			pages: 'Páginas',
			isbn: 'ISBN',
			description: 'Descripción',
			categories: 'Categorías',
			language: 'Idioma',
			preview: 'Vista previa',
			information: 'Información',
			previewError: 'Error en la vista previa',
			previewErrorDescription: 'No se puede cargar la vista previa del libro',
			untitled: 'Libro sin título',
			noData: 'Sin datos',
			noDataDescription: 'No hay información del libro disponible',
		},
		images: {
			error: 'Error al cargar imágenes',
			errorDescription: 'No se pueden cargar imágenes para este recurso',
			viewFull: 'Ver completo',
			by: 'por',
			source: 'Fuente',
			description: 'Descripción',
			preview: 'Vista previa',
			information: 'Información',
			previewError: 'Error en la vista previa',
			previewErrorDescription: 'No se pueden cargar las imágenes',
			untitled: 'Sin título',
			noData: 'Sin datos',
			noDataDescription: 'No hay información de imágenes disponible',
			gallery: 'Galería',
		},
		video: {
			invalidId: 'ID de vídeo inválido',
			browserNotSupported: 'Tu navegador no soporta el elemento de vídeo.',
			originalSite: 'Sitio original',
			markers: 'Marcadores',
			transcript: 'Transcripción',
			hide: 'Ocultar',
			show: 'Mostrar',
			loadError: 'Error al cargar el vídeo',
			loadErrorDescription: 'Intenta abrir el vídeo en su sitio original',
			sketchfabViewer: 'Visor Sketchfab',
			viewer: 'Visor 3D',
		},
		model3d: {
			error: 'Error al cargar el modelo',
			errorDescription: 'No hay URL de modelo disponible',
			unsupported: 'Formato no soportado',
			unsupportedDescription: 'Este tipo de modelo 3D no es soportado aún',
			loadError: 'Error al cargar el modelo',
			loadErrorDescription:
				'Intenta abrir el modelo en su sitio original usando el botón de arriba',
			viewOriginal: 'Ver original',
			source: 'Fuente',
			description: 'Descripción',
			preview: 'Vista previa',
			sketchfabInfo: 'Información sobre Sketchfab',
			sketchfabInfoDescription:
				'Este modelo está alojado en Sketchfab. Puedes rotarlo, hacerle zoom e interactuar con el visor 3D.',
			untitled: 'Modelo sin título',
		},
	},
} satisfies CoursesLocale

export default courses
